import { Component, OnInit, Input } from '@angular/core';
import { BaseEditor } from '../baseEditor/base.editor'

@Component({
    selector: 'ixs-textareaold',
    templateUrl: 'textarea.component.html'
})
export class TextareaComponent extends BaseEditor {
	constructor() {
		super();
	}
}


// WEBPACK FOOTER //
// ./src/app/components/textarea/textarea.component.ts